import React from 'react'
import { useState } from 'react';
import UploadedShipperAdvice from './uploadshipperadvice';
import ShipperAdvice from './shipperadvice';

const ShipperAdviceTabs = () => {
    const [isDefault, setIsDefault] = useState(false)
    return <section className="section">
        <div className="section-header">
            <ul className="nav nav-tabs">
                <li className="nav-item" onClick={() => setIsDefault(false)}><a className={`nav-link ${isDefault ? '' : 'active'}`} href="#"><h1 style={{ color: `${isDefault ? '' : '#e25a0c'}` }}>Shipper Advice</h1></a></li>
                <li className="nav-item" onClick={() => setIsDefault(true)}><a className={`nav-link ${isDefault ? 'active' : ''}`} href="#"><h1 style={{ color: `${isDefault ? '#e25a0c' : ''}` }}>Upload Shipper Advice</h1></a></li>
            </ul>
        </div>

        {isDefault ? <UploadedShipperAdvice />: <ShipperAdvice />}
    </section>
}

export default ShipperAdviceTabs;